var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"pt-4"},[_c('div',{staticClass:"d-flex"},[_c('lista-geocercas',{ref:"VerGrupos",on:{"loadGeocercas":_vm.loadGeocercas,"reload":_vm.reloadGeocercas}}),_c('div',{staticClass:"position-relative",staticStyle:{"width":"calc(100vw - 489px)"}},[_c('mapa-geocercas',{ref:"mapaGeocercas"})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }